import { GenericError, LoadingSpinner } from '@psyomics/ui-components';
import { Navigate, useParams } from 'react-router-dom';

import { useValidateOrganisationCode } from '../../../features/professional-referral/hooks/use-validate-organisation-code';
import { ProfessionalReferralWelcome } from '../../../features/professional-referral/professional-referral-welcome';

const ProfessionalReferral = () => {
  const { orgCode } = useParams<{ orgCode: string }>();
  const [result, fetching, error] = useValidateOrganisationCode(orgCode);

  if (!orgCode) return <Navigate to="/" />;
  if (fetching) return <LoadingSpinner />;
  if (error || !result) return <GenericError titleKey="common.errors.notFound" />;

  return <ProfessionalReferralWelcome cmsContentId={result.cmsContentId ?? undefined} orgCode={orgCode} />;
};

export { ProfessionalReferral };
